import React, { useMemo, useState, useEffect, useCallback } from 'react';
import { useTable, useGlobalFilter, usePagination } from 'react-table';
import { FaChevronLeft, FaChevronRight, FaAngleDoubleLeft, FaAngleDoubleRight } from 'react-icons/fa';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faComment } from '@fortawesome/free-solid-svg-icons';
import 'font-awesome/css/font-awesome.min.css';
import '../css/usermain.css';
import axios from 'axios';
import AddTaskPopup from './AddTaskPopup';
import { faSquare } from '@fortawesome/free-solid-svg-icons';
import AcademicGuruLogo from '../assets/academicguru.png';
import LeelagreenLogo from '../assets/leelagreen.jpg';
import AGPHLogo from '../assets/agph.png';
import IJISEMLogo from '../assets/ijisem.png';
import SlideTask from './SlideTask';
import TaskTimerAction from './TaskTimerAction';
import { useNavigate } from 'react-router-dom';
import ProjectSidebar from './ProjectSidebar';


const DoneTable = () => {
     const [taskData, setTaskData] = useState([]);
      const [filterInput, setFilterInput] = useState('');
      const [showPopup, setShowPopup] = useState(false);
      const [activeTab, setActiveTab] = useState('singletask');
      const [projectData, setProjectData] = useState([]);
      const [showSidebar, setShowSidebar] = useState(false);
      const [selectedRowData, setSelectedRowData] = useState(null);
      const [projectNames, setProjectNames] = useState({});
      const [selectedProject, setSelectedProject] = useState(null);
      const navigate = useNavigate();
      const [hoveredRowIndex, setHoveredRowIndex] = useState(null);
        const [sidebarOpen, setSidebarOpen] = useState(false);
      
      
        const handleRowClick = (project) => {
          setSelectedProject(project);
          setSidebarOpen(true);
        };
      
      
     
    
    
          useEffect(() => {
            fetch("/api/projectname.php?method=getNames")
              .then((res) => res.json())
              .then((data) => {
                if (data.success) {
                  setProjectNames(data.projects);
                }
              });
          }, []);
     
    
          const updateDuration = useCallback((taskId, newTimeObj) => {
            const task = taskData.find(t => t.id === taskId);
            let sessionArray = [];
          
            try {
              const parsed = JSON.parse(task?.duration || '[]');
              sessionArray = Array.isArray(parsed) ? parsed : [];
            } catch {
              sessionArray = [];
            }
    
            const lastSession = sessionArray[sessionArray.length - 1];
            let updatedSessions = [...sessionArray];
          
            // If trying to add a new "start"
            if (newTimeObj.start) {
              if (!lastSession || (lastSession.start && (lastSession.pause || lastSession.end))) {
                // Only add new start if no session or last session is finished
                updatedSessions.push({ start: newTimeObj.start });
              } else {
                console.warn("Cannot add new 'start': last session still running");
                return;
              }
            }
    
            else if (newTimeObj.pause || newTimeObj.end) {
              if (lastSession && lastSession.start && !lastSession.pause && !lastSession.end) {
                // Update the last active session with pause or end
                updatedSessions[updatedSessions.length - 1] = {
                  ...lastSession,
                  ...newTimeObj,
                };
              } else if (newTimeObj.pause && lastSession && lastSession.pause) {
                // If trying to pause again after a pause, treat it as new start
                updatedSessions.push({ start: newTimeObj.pause });
              } else {
                console.warn("Cannot add 'pause' or 'end': no active session with 'start'");
                return;
              }
            }
    
            // Save updated duration to DB
            fetch("/api/taskduration.php", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                method: "updateDuration",
                id: taskId,
                duration: JSON.stringify(updatedSessions),
              }),
            })
              .then(res => res.json())
              .then(response => {
                if (response.success) {
                  console.log("Duration updated");
          
                  // Update local state
                  setTaskData(prev =>
                    prev.map(task =>
                      task.id === taskId ? { ...task, duration: JSON.stringify(updatedSessions) } : task
                    )
                  );
                } else {
                  console.error("Update failed:", response.message);
                }
              })
              .catch(error => console.error("Error updating duration:", error));
          }, [taskData]);
    
          const filteredTasks = useMemo(() => {
      return taskData.filter(task => task.status?.toLowerCase() === 'done');
    }, [taskData]);
    
    const filteredProjects = useMemo(() => {
      return projectData.filter(project => project.status?.toLowerCase() === 'done');
    }, [projectData]);
    
    const filteredIndividualTasks = useMemo(() => {
      return filteredTasks.filter(task => task.project_id || task.project_id.trim() === '');
    }, [filteredTasks]);
    
    
          const handleStart = useCallback((task) => {
      const now = new Date().toISOString();
    
      // Check if another task is already running
      const runningTask = taskData.find(t => {
        try {
          const sessions = JSON.parse(t.duration || '[]');
          const last = sessions[sessions.length - 1];
          return last && last.start && !last.pause && !last.end;
        } catch {
          return false;
        }
      });
    
      // If another task is running and it's not the current one, block
      if (runningTask && runningTask.id !== task.id) {
        alert("Only one task can run at a time. Please pause or end the other task first.");
        return;
      }
    
      updateDuration(task.id, { start: now });
    }, [taskData, updateDuration]);
    
    
          const handlePause = useCallback((task) => {
      const now = new Date().toISOString();
    
      // Check if this task is already paused and trying to resume (unpause)
      const sessions = (() => {
        try {
          return JSON.parse(task.duration || '[]');
        } catch {
          return [];
        }
      })();
    
      const last = sessions[sessions.length - 1];
    
      const isResuming =
        last && last.start && last.pause && !last.end;
    
      if (isResuming) {
        // Check if any other task is already running
        const runningTask = taskData.find(t => {
          try {
            const s = JSON.parse(t.duration || '[]');
            const l = s[s.length - 1];
            return (
              l &&
              l.start &&
              !l.pause &&
              !l.end &&
              t.id !== task.id
            );
          } catch {
            return false;
          }
        });
    
        if (runningTask) {
          alert("Only one task can run at a time. Pause or end the other task first.");
          return;
        }
    
        // Resume by creating a new session
        updateDuration(task.id, { start: now });
        return;
      }
    
      // Otherwise, apply normal pause
      updateDuration(task.id, { pause: now });
    
    }, [taskData, updateDuration]);
    
    
          const handleEnd = useCallback((task) => {
            const now = new Date().toISOString();
            updateDuration(task.id, { end: now });
          }, [updateDuration]);
    
          useEffect(() => {
            axios.get('/api/mainuser.php?action=tasks', { withCredentials: true })
            .then(res => {setTaskData(res.data);})
            .catch(err => console.error('Fetch error:', err));
    
            axios.get('/api/mainuser.php?action=projects', { withCredentials: true })
              .then(res => setProjectData(res.data))
              .catch(err => console.error('Fetch error:', err));
          }, []);
    
    
          const renderTaskStatusSquares = (taskCountJson) => {
            let parsed = {
              "Hold": 0,
              "To Do": 0,
              "Doing": 0,
              "Done": 0
            };
    
            try {
              if (typeof taskCountJson === 'string') {
                const temp = JSON.parse(taskCountJson);
                parsed = { ...parsed, ...temp };
              } else if (typeof taskCountJson === 'object' && taskCountJson !== null) {
                parsed = { ...parsed, ...taskCountJson };
              }
            } catch (e) {
              // silently fail
            }
    
            const colorMap = {
              'Hold': 'text-gray-300',
              'To Do': 'text-red-300',
              'Doing': 'text-yellow-300',
              'Done': 'text-green-300',
            };
    
            return (
              <div className="flex flex-wrap gap-0.5">
                {['Hold','To Do', 'Doing', 'Done'].map((key) =>
                  parsed[key] > 0
                    ? [...Array(parsed[key])].map((_, idx) => (
                        <FontAwesomeIcon
                          key={`${key}-${idx}`}
                          icon={faSquare}
                          className={`text-[9px] ${colorMap[key]}`}
                        />
                      ))
                    : null
                )}
              </div>
            );
          };
    
          const columns = useMemo(() => [
    
            {
              Header: "Project Name",
              accessor: "project_id", // still use project_id to map
              Cell: ({ value }) => (
                <span title={value}>
                  {projectNames[value] || <span className='bg-gray-300 p-1 rounded shadow-xl text-gray-800 font-semibold'>Single Task</span>}
                </span>
              )
            },
            { Header: "Task ID", accessor: "task_id" },
            { Header: "Task Name", accessor: "task_name" },
            { Header: "Client", accessor: "client_name" },
           { Header: "Assign By", accessor: "assign_by" },
            {
              Header: "",
              accessor: "comment",
              Cell: ({ row }) => {
                let commentArray = [];
                const rawComment = row.original.comment;
    
                if (typeof rawComment === 'string') {
                  try {
                    const parsed = JSON.parse(rawComment);
                    commentArray = Array.isArray(parsed) ? parsed : [parsed];
                  } catch {
                    commentArray = rawComment ? [rawComment] : [];
                  }
                } else if (Array.isArray(rawComment)) {
                  commentArray = rawComment;
                } else if (rawComment) {
                  commentArray = [rawComment];
                }
                const commentCount = commentArray.length;
                return (
                  <div className="">
                    <button className="relative">
                      <FontAwesomeIcon icon={faComment} />
                      {commentCount > 0 && (
                        <span className="absolute bottom-4 left-3 bg-gray-600 text-white rounded-full text-[0.45rem] px-1">
                          {commentCount}
                        </span>
                      )}
                    </button>
                  </div>
                );
              },
            },
            {
              Header: "Priority",
              accessor: "priority",
              Cell: ({ value }) => {
                let bgColor = "transparent";
                let textColor = "inherit";
                if (value === "Medium") {
                  bgColor = "#d1fae5"; // green-100
                } else if (value === "Urgent") {
                  bgColor = "#f87171"; // red-400
                  textColor = "white";
                }
                  return (
                    <div
                      style={{
                        fontSize: '12px',
                        textAlign: 'center',
                        borderRadius: '10px',
                        backgroundColor: bgColor,
                        color: textColor,
                      }}
                    >
                      {value}
                    </div>
                  );
              }
            },
            {
              Header: "Start Date",
              accessor: "start_date",
              Cell: ({ value }) => {
                if (!value) return "";
                const date = new Date(value);
                const day = String(date.getDate()).padStart(2, '0');
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const year = date.getFullYear();
                return `${day}-${month}-${year}`;
              }
            },
            {
            Header: "Tentative Time",
            accessor: "submission_date",
            Cell: ({ value }) => value ? `${value} hr ` : '',  // Custom display
          },
          {
            Header: "Submission Date",
            accessor: "due_date",
            Cell: ({ value }) => {
              if (!value) return "";
              const date = new Date(value);
              const day = String(date.getDate()).padStart(2, '0');
              const month = String(date.getMonth() + 1).padStart(2, '0');
              const year = date.getFullYear();
              return `${day}-${month}-${year}`;
            }
          },
            {
              Header: "Action",
              accessor: "duration",
             Cell: ({ row }) => (
        <TaskTimerAction
          task={row.original}
          onStart={handleStart}
          onPause={handlePause}
          onEnd={handleEnd}
        />
      )
          } ], [handleStart, handlePause, handleEnd,  projectNames]);
    
          
    
        const projectColumns = useMemo(() => [
          {
            Header: "",
            accessor: "company_name",
            Cell: ({ value }) => {
              const companyLogoMap = {
                'IJISEM': IJISEMLogo,
                'Academic Guru': AcademicGuruLogo,
                'Leela Greens': LeelagreenLogo,
                'AGPH': AGPHLogo,
              };
              const logo = companyLogoMap[value];
              return logo ? (
                <img
                  src={logo}
                  alt={value}
                  className="h-6 w-6 rounded-full"
                  title={value}
                />
              ) : (
                <span>{value}</span>
              );
            }
          },
          {
         Header: "Project ID",
         accessor: "project_id",
         Cell: ({ row }) => (
           <button
             onClick={(e) => {
               e.stopPropagation(); // prevent triggering row navigation
               handleRowClick(row.original);
             }}
             className="text-blue-600  hover:text-blue-800"
           >
             {row.original.project_id}
           </button>
         )
       },
          { Header: "Name", accessor: "name" },
          { Header: "Client", accessor: "client" },
          { Header: "Category", accessor: "category" },
          { Header: "Manage By", accessor: "assign_to" },
          {
            Header: "Assignees",
            accessor: "team_members",
            Cell: ({ value }) => {
              if (!value) return null;
              const members = value
                .split(',')
                .map(m => m.trim())
                .filter(m => m.length > 0);
      
              return (
                <span
                  className="inline-flex items-center justify-center w-6 h-6 rounded-full text-xs font-semibold text-gray-700 bg-gray-200"
                  title={members.join(', ')} // tooltip on hover
                >
                  {members.length}
                </span>
              );
            }
          },
          {
            Header: "Progress",
            accessor: "no_of_task",
            Cell: ({ value }) => renderTaskStatusSquares(value),
          },
          { Header: "Deadline", accessor: "submisssion_date" },
        ], []);
    
      // Task Table
const {
  getTableProps, getTableBodyProps, headerGroups, prepareRow, page,
  state: taskState, nextPage, previousPage, canNextPage, canPreviousPage, pageCount,
  gotoPage, pageOptions, setPageSize, setGlobalFilter
} = useTable(
  { columns, data: filteredTasks, initialState: { pageIndex: 0, pageSize: 20 } },
  useGlobalFilter,
  usePagination
);

// Project Table
const {
  getTableProps: getProjectTableProps,
  getTableBodyProps: getProjectTableBodyProps,
  headerGroups: projectHeaderGroups,
  prepareRow: prepareProjectRow,
  page: projectPage,
  state: projectState,
  nextPage: nextProjectPage,
  previousPage: previousProjectPage,
  canNextPage: canProjectNextPage,
  canPreviousPage: canProjectPrevPage,
  pageCount: projectPageCount,
  gotoPage: gotoProjectPage,
  pageOptions: projectPageOptions,
  setPageSize: setProjectPageSize,
  setGlobalFilter: setProjectGlobalFilter
} = useTable(
  { columns: projectColumns, data: filteredProjects, initialState: { pageIndex: 0, pageSize: 20 } },
  useGlobalFilter,
  usePagination
);

// Individual Task Table
const {
  getTableProps: getIndividualTableProps,
  getTableBodyProps: getIndividualTableBodyProps,
  headerGroups: individualHeaderGroups,
  prepareRow: prepareIndividualRow,
  page: individualPage,
  state: individualState,
  nextPage: nextIndividualPage,
  previousPage: previousIndividualPage,
  canNextPage: canIndividualNextPage,
  canPreviousPage: canIndividualPrevPage,
  pageCount: individualPageCount,
  gotoPage: gotoIndividualPage,
  pageOptions: individualPageOptions,
  setPageSize: setIndividualPageSize,
  setGlobalFilter: setIndividualGlobalFilter
} = useTable(
  { columns, data: filteredIndividualTasks, initialState: { pageIndex: 0, pageSize: 20 } },
  useGlobalFilter,
  usePagination
);

    
    
  return (
   <div className="container-dash  pt-5 px-6  h-200">
          <div className="d-flex justify-content-center mb-6">
            <div className="search shadow-xl">
              <input
                className="search_input"
                type="text"
                placeholder="Search here..."
                value={filterInput}
                onChange={e => {
                  setFilterInput(e.target.value);
                  if (activeTab === 'Task') {
                    setGlobalFilter(e.target.value);
                  } else if (activeTab === 'Project') {
                    setProjectGlobalFilter(e.target.value);
                  } else {
                    setIndividualGlobalFilter(e.target.value);
                  }
                }}
              />
              <a href="#/" className="search_icon" onClick={e => e.preventDefault()}>
                <i className="fa fa-search"></i>
              </a>
            </div>
          </div>
          <div className='flex text-right  mr-3 font-semibold text-gray-500 justify-between'>
            <div className="flex space-x-4 mb-4">
              <button
                onClick={() => setActiveTab('singletask')}
                className={`p-4 pt-1 pb-1  shadow-xl rounded ${activeTab === 'singletask' ? 'bg-gray-700 text-white' : 'bg-white text-gray-700 '}`}
              >
                🎯 Tasks
              </button>
              <button
                onClick={() => setActiveTab('Project')}
                className={`p-4 pt-1 pb-1  shadow-xl rounded ${activeTab === 'Project' ? 'bg-gray-700 text-white' : 'bg-white text-gray-700 '}`}
              >
                📁 Projects
              </button>
            </div>
            <div>
              
            </div>
          </div>
      {activeTab === 'Task' ? (
        <>
          {showPopup && <AddTaskPopup onClose={() => setShowPopup(false)} />}
            {/* Task Table Here */}
                <div className="overflow-x-auto bg-white  shadow w-full shadow-xl overflow-y-auto max-h-150 scrollbar-hide ">
              <table {...getTableProps()} className="min-w-full divide-y divide-gray-200 ">
                {/* Task Table Headers */}
                <thead className="bg-gray-700 sticky top-0 z-0">
                      {headerGroups.map(headerGroup => (
                        <tr key={headerGroup.id} {...headerGroup.getHeaderGroupProps()}>
                          {headerGroup.headers.map(column => {
                            const { key, ...restProps } = column.getHeaderProps();
                            return (
                              <th key={key} {...restProps} className="px-3 py-3 text-left text-xs font-medium text-white uppercase tracking-wider">
                                {column.render("Header")}
                              </th>
                            );
                      })}
                    </tr>
                  ))}
                </thead>
                <tbody {...getTableBodyProps()} className="divide-y divide-gray-200">
                  {page.map((row, idx) => {
                    prepareRow(row);
                    const { key, ...rowProps } = row.getRowProps(); 
                    return (
                      <tr
                        key={key}
                        {...rowProps}
                        className="hover:bg-gray-50 cursor-pointer"
                        onClick={() => {
                          setSelectedRowData(row.original); // row.original has full raw data
                          setShowSidebar(true);
                        }}
                      >
                        {row.cells.map(cell => {
                          const { key: cellKey, ...cellProps } = cell.getCellProps();
                          return (
                            <td key={cellKey} {...cellProps} className="px-3 py-3 text-xs text-gray-700 ">
                              {cell.render('Cell')}
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })}
                </tbody>
            </table>
          </div>
          {/* Slide-in Sidebar */}
      <SlideTask
        show={showSidebar}
        onClose={() => setShowSidebar(false)}
        data={selectedRowData}
      />
        </>
     ) : activeTab === 'singletask' ? (
        <>
          <div className="overflow-x-auto bg-white rounded shadow w-full shadow-xl overflow-y-auto max-h-150 scrollbar-hide">
            <table {...getIndividualTableProps()} className="min-w-full divide-y divide-gray-200">
    <thead className="bg-gray-700 sticky top-0 z-0">
      {individualHeaderGroups.map(headerGroup => {
        const { key, ...restHeaderGroupProps } = headerGroup.getHeaderGroupProps();
        return (
          <tr key={key} {...restHeaderGroupProps}>
            {headerGroup.headers.map(column => {
              const { key, ...restColumnProps } = column.getHeaderProps();
              return (
                <th
                  key={key}
                  {...restColumnProps}
                  className="px-3 py-3 text-left text-xs font-medium text-white uppercase tracking-wider whitespace-nowrap"
                >
                  {column.render('Header')}
                </th>
              );
            })}
          </tr>
        );
      })}
    </thead>

    <tbody {...getIndividualTableBodyProps()} className="divide-y divide-gray-200">
      {individualPage.map(row => {
        prepareIndividualRow(row);
        const { key, ...restRowProps } = row.getRowProps();
        return (
          <tr
            key={key}
            {...restRowProps}
            className={`cursor-pointer ${hoveredRowIndex === row.id ? 'bg-gray-100' : ''}`}
  onMouseEnter={() => setHoveredRowIndex(row.id)}
            onClick={() => {
              setSelectedRowData(row.original);
              setShowSidebar(true);
            }}
          >
            {row.cells.map(cell => {
              const { key, ...restCellProps } = cell.getCellProps();
              return (
                <td
                  key={key}
                  {...restCellProps}
                  className="px-3 py-3 text-xs text-gray-700 "
                >
                  {cell.render('Cell')}
                </td>
              );
            })}
          </tr>
        );
      })}
    </tbody>
  </table>
          </div>
        {/* 👇 Sidebar for Single Task */}
        <SlideTask
          show={showSidebar}
          onClose={() => setShowSidebar(false)}
          data={selectedRowData}
        />
      </>
      ) : (
      <div className="overflow-x-auto bg-white rounded shadow w-full shadow-xl overflow-y-auto max-h-150 scrollbar-hide">
<table {...getProjectTableProps()} className="min-w-full divide-y divide-gray-200 ">
  <thead className="bg-gray-700 sticky top-0 z-0">
    {projectHeaderGroups.map(headerGroup => {
      const { key, ...restHeaderProps } = headerGroup.getHeaderGroupProps();
      return (
        <tr key={key} {...restHeaderProps}>
          {headerGroup.headers.map(column => {
            const { key, ...restColProps } = column.getHeaderProps();
            return (
              <th
                key={key}
                {...restColProps}
                className="px-3 py-3 text-left text-xs font-medium text-white uppercase tracking-wider whitespace-nowrap"
              >
                {column.render('Header')}
              </th>
            );
          })}
        </tr>
      );
    })}
  </thead>

  <tbody {...getProjectTableBodyProps()} className="divide-y divide-gray-200">
    {projectPage.map(row => {
      prepareProjectRow(row);
      const { key, ...restRowProps } = row.getRowProps();
      return (
        <tr key={key} {...restRowProps}  onClick={() => navigate(`/${row.original.project_id}?user=${row.original.assign_to}`)} className={`cursor-pointer ${hoveredRowIndex === row.id ? 'bg-gray-100' : ''}`}
  onMouseEnter={() => setHoveredRowIndex(row.id)}>
          {row.cells.map(cell => {
            const { key, ...restCellProps } = cell.getCellProps();
            return (
              <td
                key={key}
                {...restCellProps}
                className="px-3 py-3 text-xs text-gray-700 "
              >
                {cell.render('Cell')}
              </td>
            );
          })}
        </tr>
      );
    })}
  </tbody>
</table>

  
   
      </div>
    )}

    
    {showPopup && <AddTaskPopup onClose={() => setShowPopup(false)} />}
        {/* Pagination */}
        <div className="flex items-center justify-between mt-4">
  {activeTab === 'Task' && (
    <>
      <div className="text-sm text-gray-800 font-bold">Page {taskState.pageIndex + 1} of {pageOptions.length}</div>
      <div className="flex items-center space-x-2">
        <button onClick={() => gotoPage(0)} disabled={!canPreviousPage}><FaAngleDoubleLeft /></button>
        <button onClick={() => previousPage()} disabled={!canPreviousPage}><FaChevronLeft /></button>
        <button onClick={() => nextPage()} disabled={!canNextPage}><FaChevronRight /></button>
        <button onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}><FaAngleDoubleRight /></button>
      </div>
      <select value={taskState.pageSize} onChange={e => setPageSize(Number(e.target.value))}>
        {[20, 50, 100].map(size => <option key={size} value={size}>Show {size}</option>)}
      </select>
    </>
  )}

  {activeTab === 'Project' && (
    <>
      <div className="text-sm text-gray-800 font-bold">Page {projectState.pageIndex + 1} of {projectPageOptions.length}</div>
      <div className="flex items-center space-x-2">
        <button onClick={() => gotoProjectPage(0)} disabled={!canProjectPrevPage}><FaAngleDoubleLeft /></button>
        <button onClick={() => previousProjectPage()} disabled={!canProjectPrevPage}><FaChevronLeft /></button>
        <button onClick={() => nextProjectPage()} disabled={!canProjectNextPage}><FaChevronRight /></button>
        <button onClick={() => gotoProjectPage(projectPageCount - 1)} disabled={!canProjectNextPage}><FaAngleDoubleRight /></button>
      </div>
      <select value={projectState.pageSize} onChange={e => setProjectPageSize(Number(e.target.value))}>
        {[20, 50, 100].map(size => <option key={size} value={size}>Show {size}</option>)}
      </select>
    </>
  )}

  {activeTab === 'singletask' && (
    <>
      <div className="text-sm text-gray-800 font-bold">Page {individualState.pageIndex + 1} of {individualPageOptions.length}</div>
      <div className="flex items-center space-x-2">
        <button onClick={() => gotoIndividualPage(0)} disabled={!canIndividualPrevPage}><FaAngleDoubleLeft /></button>
        <button onClick={() => previousIndividualPage()} disabled={!canIndividualPrevPage}><FaChevronLeft /></button>
        <button onClick={() => nextIndividualPage()} disabled={!canIndividualNextPage}><FaChevronRight /></button>
        <button onClick={() => gotoIndividualPage(individualPageCount - 1)} disabled={!canIndividualNextPage}><FaAngleDoubleRight /></button>
      </div>
      <select value={individualState.pageSize} onChange={e => setIndividualPageSize(Number(e.target.value))}>
        {[20, 50, 100].map(size => <option key={size} value={size}>Show {size}</option>)}
      </select>
    </>
  )}

  {sidebarOpen && (
  <div className="fixed inset-0 z-40  backdrop-blur-sm transition-opacity duration-300">
    <ProjectSidebar
      isOpen={sidebarOpen}
      onClose={() => setSidebarOpen(false)}
      project={selectedProject}
    />
  </div>
)}
</div>


        </div>

        
  
  )
}

export default DoneTable